import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import getI18nextConfig from './i18next.config';

async function configureI18n(useMockTranslations = false): Promise<void> {
  await i18n.use(initReactI18next).init(getI18nextConfig(useMockTranslations));
}

export default configureI18n;
